/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    enum Roles {
        MiddleSchool = 1 << 0, // 1
        HighSchool = 1 << 1, // 2
        College = 1 << 2, // 4
        AdultLearner = 1 << 3, // 8
        Parent = 1 << 4, // 16
        EducationProfessional = 1 << 5, // 32
        NC529AccountHolder = 1 << 6, // 64
        EducationLoanBorrower = 1 << 7 // 128
    };

    class UserProfile implements IUserProfile {
        addressVerified: boolean;
        associatedSchools: Array<ICustomerViewModel>;
        comments: Array<any>;
        customer: ICustomerViewModel;
        dateOfBirth: string;
        daytimePhone: string;
        email: string;
        enrollmentStatus: number;
        eveningPhone: string;
        firstName: string;
        fromServer: boolean;
        gender: number;
        graduationYear: number;
        id: number;
        lastName: string;
        mailAddress: IAddress;
        mailingPhone: string;
        middleName: string;
        nickname: string;
        permAddress: IAddress;
        phoneNumber: string;
        primaryConnectionCrmId: number;
        role: any;
        socialSecurityNumber: string;
        studentId: string;
        suffix: string;
        userContactInfo: any;
        username: string;
        mobilePhone: string;
        homePhone: string;
        workPhone: string;
        emailInvalid: boolean;
        addressInvalid: boolean;
        phoneNumberInvalid: boolean;
        passwordInvalid: boolean;
        textingOptIns: ITextingOptIns;
        emailIsValid: boolean;
        emailVerified: boolean;
        emailSignature: string;
        tin: string;
    }

    interface INextStepsPathway {
        log: (msg: string, data?: any, showToast?: boolean) => void;
        logError: (msg: string, data?: any, showToast?: boolean) => void;
        logSuccess: (msg: string, data?: any, showToast?: boolean) => void;
        currentStep: any;
    }

    class NextStepsPathway implements INextStepsPathway {
        static controllerId: string = "collegePath";
        static $inject: Array<string> = ["common", "config", "$location", "$routeParams", "Restangular"];
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        currentStep: number = 1;
        umbracoUrl: string;
        pathway: IPathway;
        pathwayId: number = 0;
        steps = [];
        pwSteps: IPathwayStepDefinition[] = null;
        saving: boolean = false;
        loading: boolean = false;
        pathways = {
            college: 0,
            workforce: 1,
            military: 2
        };
        user: UserProfile;
        convertedRoles: Array<any>;
        roles: Array<any>;
        isEducatorRole: boolean;
        formCompleted: boolean = false;

        constructor(private common: ICommonFactory,
            private config: IConfig,
            private $location: ng.ILocationService,
            private $routeParams: ng.route.IRouteParamsService,
            private Restangular: Restangular.IService) {

            this.log = common.logger.getLogFn(NextStepsPathway.controllerId);
            this.logError = common.logger.getLogFn(NextStepsPathway.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(NextStepsPathway.controllerId, "success");
            this.umbracoUrl = config.umbracoUrl;
            this.pathwayId = this.pathways[this.$routeParams["pathway"].toLowerCase()]
            this.convertedRoles = [];
            this.roles = [{ value: 1, name: "Middle School or Junior High School Student" },
            { value: 2, name: "High School Student" },
            { value: 4, name: "College or Postsecondary School Student" },
            { value: 8, name: "Adult" },
            { value: 16, name: "Parent" },
            { value: 32, name: "Education Professional" },
            { value: 64, name: "NC 529 Account Holder" },
            { value: 128, name: "Education Loan Borrower" },
            ];

            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.common.authentication.isLoggedIn().then(loggedIn => {
                        if (loggedIn) {
                            this.activate();
                        }
                    });
                }
            });
        }

        activate() {
            this.loading = true;
            var promises = [this.getProfile(), this.isTypeFormComplete(), this.getSteps(), this.getPathway()];
            this.common.activateController(promises, NextStepsPathway.controllerId)
                .then(() => {
                    this.log("Activated Next Steps View");

                    if (!this.isEducatorRole && this.formCompleted == false) {
                        this.$location.path("/next-step");
                    }

                    for (var step of this.pathway.steps) {
                        step.responses.sort((a, b) => a.question - b.question);

                        var pwStep = this.pwSteps.filter(s => s.stepNumber == step.stepNumber)[0];

                        pwStep.complete = step.dateCompleted != null;

                        pwStep.questions.forEach(q => {
                            var response = step.responses.filter(r => r.question == q.order)[0];

                            if (response != null) {

                                if (q.type == 'singleselect') {
                                    q.choices.forEach(c => {
                                        c.selected = c.value.toString() == response.answer
                                        if (c.selected) {
                                            q.selected = c.value;
                                        }
                                    });
                                };

                                if (q.type == 'multiselect') {
                                    var values = response.answer.split(",");
                                    q.choices.forEach(c => {
                                        c.selected = values.indexOf(c.value.toString()) > -1 ? c.value : false;

                                    });
                                }

                                if (q.type == 'shortanswer') {
                                    var values = response.answer.split(",");
                                    q.choices.forEach((c, i: number) => {
                                        c.value = values[i];
                                    });
                                }
                            }

                            if (q.type == 'rating') {
                                q.choices.forEach(c => {
                                    var response = step.responses.filter(r => r.question == c.order)[0];
                                    c.selected = response.answer;
                                });
                            }
                        });



                    }
                    this.currentStep = Math.max(1, Math.min(this.pwSteps.length, this.getMaxCompletedStep() + 1));


                    this.loading = false;
                });
        }

        getPathway() {
            return this.Restangular
                .one("nextSteps/pathways", this.pathwayId)
                .get()
                .then((result) => {
                    if (result) {
                        this.pathway = result;
                    }
                }, (reason) => {
                    this.logError(reason, reason, true);
                });
        }



        gotoStep(stepNumber: number) {
            if (stepNumber <= this.getMaxCompletedStep() + 1 || _.some(this.convertedRoles, r => r.value == 32)) {
                this.currentStep = stepNumber;
                if (stepNumber == this.pwSteps.length) {
                    this.pathway.dateCompleted = new Date();
                }
            }
        }

        saveStep(stepNumber: number) {
            this.saving = true;
            var step = this.pwSteps.filter(s => s.stepNumber == stepNumber)[0];
            var data = [];
            step.questions.forEach(q => {
                if (q.type == 'singleselect') {
                    data.push({
                        step: step.stepNumber,
                        question: q.order,
                        answer: q.selected
                    });
                }

                if (q.type == 'multiselect') {
                    var answer = [];
                    q.choices
                        .filter(c => c.selected != false)
                        .forEach(c => {
                            answer.push(c.selected);
                        });

                    data.push({
                        step: step.stepNumber,
                        question: q.order,
                        answer: answer.join(",")
                    });
                }

                if (q.type == 'rating') {
                    q.choices.forEach(c => {
                        data.push({
                            step: step.stepNumber,
                            question: c.order,
                            answer: c.selected
                        })
                    });
                }

                if (q.type == 'shortanswer') {
                    var answer = [];
                    q.choices.forEach(c => {
                        answer.push(c.value);
                    });

                    data.push({
                        step: step.stepNumber,
                        question: q.order,
                        answer: answer.join(",")
                    });
                }
            });

            this.Restangular
                .all("nextsteps")
                .one("pathways", this.pathwayId)
                .one("steps")
                .post(stepNumber, data)
                .then(() => {
                    step.complete = true;

                    this.saving = false;
                }, err => this.logError("An error occurred saving your answers.", err, true),
                    () => { this.saving = false; }
                );


        }


        choiceStatus(stepNumber, questionNumber, choiceNumber) {
            var step = this.pwSteps.filter(s => s.stepNumber == stepNumber)[0];
            var question = step.questions.filter(q => q.order == questionNumber)[0];
            var choice = question.choices.filter(c => c.order == choiceNumber)[0];

            if (question.type == 'singleselect') {
                if (question.selected == choice.value && choice.isCorrect) {
                    return "correct";
                }
                if (question.selected != choice.value && choice.isCorrect) {
                    return "missed";
                }
                if (question.selected == choice.value && !choice.isCorrect) {
                    return "incorrect";
                }
            }

            if (question.type == 'multiselect') {
                if (choice.selected && choice.isCorrect) {
                    return "correct";
                }
                if (!choice.selected && choice.isCorrect) {
                    return "missed";
                }
                if (choice.selected && !choice.isCorrect) {
                    return "incorrect";
                }
            }
        }

        multiSelectIsValid(stepNumber, questionNumber) {
            var step = this.pwSteps.filter(s => s.stepNumber == stepNumber)[0];
            var question = step.questions.filter(q => q.order == questionNumber)[0];


            if (question.type == 'multiselect') {
                var arr = question.choices.filter(c => c.selected);
                return arr.length > 0;
            }
        }

        isStepValid(form, step) {
            if (step && step.isValid) {
                return step.isValid({ form, step });
            }

            return form.$valid
        }

        getMaxCompletedStep() {
            var pwStep = this.pwSteps
                .filter(step => step.complete)
                .sort((a, b) => b.stepNumber - a.stepNumber)[0];

            if (pwStep != null) {
                return pwStep.stepNumber;
            }

            return 0;
        }

        getSteps() {
            return this.Restangular
                .all("nextsteps")
                .one("pathwaydefinitions", this.pathwayId)
                .get()
                .then((response) => {
                    this.pwSteps = JSON.parse(response.pathwayStepsJson);
                },
                    err => this.logError("An error occurred geting the pathway information.", err, true)
            )
        }

        getProfile() {
            return this.Restangular.one("users/profile").get()
                .then((result) => {
                    if (result) {
                        this.user = result;
                        this.getRoles();
                        this.isEducatorRole = _.some(this.convertedRoles, r => r.value == 32);
                    }
                }, (reason) => {
                    this.logError("An error occurred getting the user's profile.", reason, true);
                });
        }

        getRoles = () => {
            var userRoles = this.bitToFormValue(this.user.role);
            for (let i = 0; i < userRoles.length; i++) {
                if (userRoles[i]) {
                    this.convertedRoles.push(this.roles[i]);
                }
            }
        }



        bitToFormValue = (bit: number): any => {
            const bits = this.enumToBitValues();
            return bits.map((b) => (bit & b) === b);
        }

        enumToBitValues = (): any[] => {
            return Object.keys(Roles).map(Number).filter(Boolean)
        };

        isTypeFormComplete() {
            return this.Restangular.all("nextsteps").one("formcomplete").get()
                .then(result => {
                    this.formCompleted = result;
                }, err => this.logError("An error occurred getting the Nest Steps form status.", err, false));
        }

    }

    angular.module("app").controller(NextStepsPathway.controllerId, NextStepsPathway);
}

